import { createAsyncThunk } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';

// Dashboard → Batch Attendance Analytics. Each view keeps its data in local state, so these are plain thunks.
// All accept { from, to } (YYYY-MM-DD, optional); empty values are dropped from the query string.

const query = (params = {}) =>
  new URLSearchParams(Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined));

export const getAttendanceOverview = createAsyncThunk('batchAttendanceAnalytics/overview', (params, { signal }) =>
  apiRequest({ method: 'get', url: `batch-attendance-analytics/overview?${query(params)}`, signal }),
);

export const getBatchAttendance = createAsyncThunk('batchAttendanceAnalytics/batch', ({ batchId, ...params }, { signal }) =>
  apiRequest({ method: 'get', url: `batch-attendance-analytics/batch/${batchId}?${query(params)}`, signal }),
);

export const getStudentAttendance = createAsyncThunk(
  'batchAttendanceAnalytics/student',
  ({ batchAssignmentId, ...params }, { signal }) =>
    apiRequest({ method: 'get', url: `batch-attendance-analytics/student/${batchAssignmentId}?${query(params)}`, signal }),
);
